import React, { useMemo, useState } from 'react';

export type TUseBooleanFunction = () => void;

export interface IUseBooleanChangeValue {
  setTrue: TUseBooleanFunction;
  setFalse: TUseBooleanFunction;

  (): void;
}

export type TUseBooleanState = [
  boolean,
  IUseBooleanChangeValue,
  React.Dispatch<React.SetStateAction<boolean>>,
];

export default (initialState: unknown = false): TUseBooleanState => {
  const [value, setValue] = useState(Boolean(initialState));

  const changeValue = useMemo(() => {
    const changeValueObject = () => setValue((prevValue) => !prevValue);
    changeValueObject.setTrue = () => setValue(true);
    changeValueObject.setFalse = () => setValue(false);
    return changeValueObject;
  }, []);

  return [value, changeValue, setValue];
};
